<template>
  <div id="main">
    <div id="manu">
      <navigation />
    </div>
    <div id="contentBox">
      <div class="registervideoContainer"></div>
      <div class="w">
        <div class="settings-section">
          <h3 class="settings-title">设置</h3>
          <div class="settings-item">
            <label>更换壁纸</label>
            <input type="file" ref="wallpaperInput" @change="changeWallpaper" accept="image/*" class="settings-input">
          </div>
          <div class="settings-item">
            <label>关闭壁纸</label>
            <label class="switch">
              <input type="checkbox" v-model="isWallpaperEnabled" @change="toggleWallpaper">
              <span class="slider"></span>
            </label>
          </div>
          <div class="settings-item">
            <label>主题模式</label>
            <label class="switch">
              <input type="checkbox" v-model="isLightTheme" @change="updateTheme">
              <span class="slider"></span>
            </label>
            <span>{{ isLightTheme ? '亮色主题' : '暗色主题' }}</span>
          </div>
          <div class="settings-item">
            <button @click="saveSettings" class="settings-button">
                <svg t="1749221496904" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2357" width="25" height="20">
                    <path d="M819.823 83.694H206.991c-67.703 0-122.588 54.885-122.588 122.588v612.833c0 67.703 54.885 122.588 122.588 122.588h612.833c67.703 0 122.588-54.885 122.588-122.588V206.282c-0.001-67.703-54.885-122.588-122.589-122.588z m-124.435 63.313v241.142H331.772V147.007h363.616z m185.787 672.274c0.027 33.765-27.323 61.158-61.088 61.185H207.133c-16.389 0-31.864-6.297-43.454-17.887s-18.039-26.91-18.039-43.298v-612.94c0.061-33.923 27.57-61.395 61.493-61.41h61.327v245.294c-0.05 33.771 27.286 61.187 61.057 61.237h367.888c33.853 0 61.299-27.387 61.299-61.237V144.931h61.206c33.872 0.036 61.301 27.524 61.265 61.396V819.281z" fill="#1296db" p-id="2358"></path><path d="M574.817 329.936c17.483 0 31.656-14.173 31.656-31.656v-61.292c0-17.483-14.173-31.656-31.656-31.656s-31.656 14.173-31.656 31.656v61.292c0 17.483 14.173 31.656 31.656 31.656z" fill="#1296db" p-id="2359"></path>
                </svg>
                保存设置
            </button>
          </div>
          <div class="settings-item">
            <button @click="logout" class="logout-button">
                <svg t="1749133661203" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9372" width="25" height="20">
                    <path d="M512 453.7c-17.7 0-32-14.3-32-32V117.9c0-17.7 14.3-32 32-32s32 14.3 32 32v303.8c0 17.7-14.3 32-32 32z" fill="#1296db" p-id="9373"></path><path d="M512 938.2c-193.4 0-350.7-157.3-350.7-350.7 0-130.4 71.8-249.3 187.4-310.2 15.6-8.2 35-2.3 43.3 13.4 8.2 15.6 2.3 35-13.4 43.3-94.6 49.8-153.3 147-153.3 253.6 0 158.1 128.6 286.7 286.7 286.7s286.7-128.6 286.7-286.7c0-106.3-58.4-203.3-152.5-253.3-15.6-8.3-21.5-27.7-13.3-43.3 8.3-15.6 27.7-21.5 43.3-13.3 115 61.1 186.5 179.8 186.5 309.8 0 193.4-157.3 350.7-350.7 350.7z" fill="#1296db" p-id="9374"></path>
                </svg>
                退出登录
            </button>
          </div>
        </div>
        <!-- <div class="Version_cover" v-if="VersionFlag">
          <div class="center_box">
            <h3>发现新版本</h3>
            <div class="explain" v-html="VersionExplain"></div>
            <div class="btn" @click="upgrade">前往升级</div>
            <div class="close-btn" @click="closeVersionCover">×</div>
          </div>
        </div> -->
        <div v-if="loading" class="loading">加载中...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error: null,
    //   VersionFlag: false,
    //   VersionExplain: '发现新版本 1.1，建议立即更新以获得最新功能。',
    //   currentVersion: '1.0',
    //   versionFileUrl: 'https://example.com/uno.apk',
      isWallpaperEnabled: true,
      isLightTheme: false,
      backgroundImage: null
    };
  },
  mounted() {
    this.loadSettings();
    this.checkVersion();
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!token || !isLoggedIn) {
      this.$message.error('请先登录');
      this.$router.push('/login');
    }
  },
  methods: {
    loadSettings() {
      try {
        const settings = JSON.parse(localStorage.getItem('appSettings') || '{}');
        this.isWallpaperEnabled = settings.isWallpaperEnabled !== undefined ? settings.isWallpaperEnabled : true;
        this.isLightTheme = settings.isLightTheme || false;
        this.backgroundImage = settings.backgroundImage || null;
        this.applySettings();
      } catch (e) {
        console.error('加载设置失败:', e);
        this.error = '加载设置失败，请重试';
      }
    },
    changeWallpaper(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.backgroundImage = e.target.result;
          this.applyBackground();
        };
        reader.onerror = () => {
          this.error = '文件读取失败';
        };
        reader.readAsDataURL(file);
      }
    },
    toggleWallpaper() {
      if (!this.isWallpaperEnabled) {
        this.backgroundImage = null;
        this.applyBackground();
        this.$message.success('已关闭壁纸');
      } else {
        const settings = JSON.parse(localStorage.getItem('appSettings') || '{}');
        this.backgroundImage = settings.backgroundImage || null;
        this.applyBackground();
      }
    },
    applyBackground() {
      const root = document.querySelector('#contentBox');
      if (root) {
        if (this.isWallpaperEnabled && this.backgroundImage) {
          root.style.backgroundImage = `url(${this.backgroundImage})`;
          root.style.backgroundSize = 'cover';
          root.style.backgroundPosition = 'center';
          root.style.backgroundRepeat = 'no-repeat';
        } else {
          root.style.backgroundImage = 'none';
        }
      }
    },
    updateTheme() {
      const root = document.querySelector('#contentBox');
      if (root) {
        if (this.isLightTheme) {
          root.style.backgroundColor = '#ffffff';
          root.style.color = '#000000';
          document.querySelectorAll('.settings-button, .logout-button').forEach(btn => {
            btn.style.color = '#000000';
          });
          document.querySelectorAll('.settings-title, label, span').forEach(el => {
            el.style.color = '#000000';
          });
        } else {
          root.style.backgroundColor = '#000000';
          root.style.color = '#ffffff';
          document.querySelectorAll('.settings-button, .logout-button').forEach(btn => {
            btn.style.color = '#ffffff';
          });
          document.querySelectorAll('.settings-title, label, span').forEach(el => {
            el.style.color = '#ffffff';
          });
        }
      }
    },
    applySettings() {
      this.applyBackground();
      this.updateTheme();
    },
    saveSettings() {
      try {
        const settings = {
          isWallpaperEnabled: this.isWallpaperEnabled,
          isLightTheme: this.isLightTheme,
          backgroundImage: this.backgroundImage
        };
        localStorage.setItem('appSettings', JSON.stringify(settings));
        this.$message.success('设置已保存');
      } catch (e) {
        this.error = '保存设置失败';
        console.error('保存设置失败:', e);
      }
    },
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' })
        .then(() => {
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('userId');
          localStorage.removeItem('username');
          localStorage.removeItem('token');
          this.$message.success('已退出登录');
          this.$router.push('/login');
        })
        .catch(() => {});
    },
    checkVersion() {
      this.VersionFlag = true;
    },
    // upgrade() {
    //   const link = document.createElement('a');
    //   link.href = this.versionFileUrl;
    //   link.download = 'uno.apk';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   this.$message.success('下载完成，请手动安装新版本');
    //   this.closeVersionCover();
    // },
    closeVersionCover() {
      this.VersionFlag = false;
    }
  }
};
</script>

<style scoped>
.w {
  width: 1700px;
  margin: 0 auto;
}
img {
  width: 100%;
  height: 100%;
  display: block;
}
#home {
  width: 100%;
}
#contentBox {
  width: 100%;
  height: 100%;
  position: relative;
  background-repeat: no-repeat;
  overflow: auto;
  z-index: 0;
  transition: background-color 0.3s, color 0.3s, background-image 0.3s;
}
.registervideoContainer {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 0rem;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url(../assets/2.jpg);
  filter: blur(6px);
}
.settings-section {
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.settings-title {
  font-size: 35px;
  color: #054e61b4;
  margin-bottom: 30px;
}
.settings-item {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
.settings-item label {
  font-size: 18px;
  color: #ffffff;
}
.settings-input {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 10px;
}
.settings-button, .logout-button {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 9px;
  background-color: #4bd5db;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.3s;
}
.logout-button {
  background-color: #ff4400b6;
}
.settings-button:hover, .logout-button:hover {
  background-color: #00a7b38c;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #4bd5db;
}
input:checked + .slider:before {
  transform: translateX(26px);
}
.loading, .error {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
}
.Version_cover {
  width: 100%;
  height: 100vh;
  background: #000000b3;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}
.Version_cover .center_box {
  width: 15%;
  height: 15rem;
  border-radius: 0.533333rem;
  background: #7bbfd4af;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Version_cover .center_box h3 {
  width: 100%;
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  padding: 0.266666rem;
}
.Version_cover .center_box .explain {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.2rem;
  opacity: 0.9;
}
.Version_cover .center_box .btn {
  width: 80%;
  height: 3rem;
  background: #ff4400b6;
  border-radius: 0.533333rem;
  font-size: 2rem;
  color: #ffffff;
  line-height: 3.066666rem;
  text-align: center;
  letter-spacing: 1px;
  position: absolute;
  bottom: 0.266666rem;
  left: 50%;
  transform: translateX(-50%);
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 33px;
  color: #000000;
}
@media screen and (max-width: 1600px) {
  .w {
    max-width: 1400px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1400px) {
  .w {
    max-width: 1200px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1200px) {
  .w {
    max-width: 1000px;
  }
  .registervideoContainer {
    margin-left: -3.5rem;
  }
}
@media screen and (max-width: 1000px) {
  .w {
    max-width: 100%;
  }
  .Version_cover .center_box {
    width: 65%;
    height: 15rem;
    border-radius: 0.533333rem;
    background: rgba(123, 191, 212, 0.685);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 550px) {
  .w {
    max-width: 100%;
  }
  .Version_cover .center_box {
    width: 65%;
    height: 15rem;
    border-radius: 0.533333rem;
    background: rgba(123, 191, 212, 0.685);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>